export function BrandMark({ className = "", variant = "full" }) {
  if (variant === "wordmark") {
    return (
      <span
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "baseline",
          fontWeight: 900,
          fontSize: "1.65rem",
          letterSpacing: "-0.04em",
          lineHeight: 1,
          color: "currentColor",
          userSelect: "none",
          whiteSpace: "nowrap",
        }}
      >
        FATBET
      </span>
    );
  }
  return (
  <svg
    className={`max-w-brand-logo w-full ${className}`.trim()}
    viewBox="0 0 140 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "auto", display: "block" }}
  >
    <path
      d="M65.0634 3.96593C65.2064 3.43246 65.7547 3.11588 66.2882 3.25882L84.3239 8.09149C84.8574 8.23443 85.174 8.78276 85.0311 9.31623L78.415 34.0079C78.272 34.5413 77.7237 34.8579 77.1902 34.715L59.1545 29.8823C58.621 29.7394 58.3044 29.191 58.4473 28.6575L65.0634 3.96593Z"
      fill="#EA1D1D"
    />
    <g filter="url(#filter0_d_30_1508)">
      <path
        d="M49.2588 10.1437C49.1159 9.61019 49.4325 9.06186 49.9659 8.91892L68.0017 4.08625C68.5351 3.94331 69.0835 4.25989 69.2264 4.79336L75.8425 29.485C75.9855 30.0184 75.6689 30.5668 75.1354 30.7097L57.0997 35.5424C56.5662 35.6853 56.0179 35.3687 55.8749 34.8353L49.2588 10.1437Z"
        fill="#901DEA"
      />
    </g>
    <path
      d="M19.3638 15.3999C19.5691 15.3999 19.7465 15.4746 19.8958 15.6239C20.0451 15.7732 20.1198 15.9506 20.1198 16.1559V20.4119C20.1198 20.6172 20.0451 20.7946 19.8958 20.9439C19.7465 21.0932 19.5691 21.1679 19.3638 21.1679H8.35981V22.9599H17.5438C17.7491 22.9599 17.9265 23.0346 18.0758 23.1839C18.2251 23.3332 18.2998 23.5106 18.2998 23.7159V27.9439C18.2998 28.1492 18.2251 28.3266 18.0758 28.4759C17.9265 28.6252 17.7491 28.6999 17.5438 28.6999H8.35981V34.2439C8.35981 34.4492 8.28514 34.6266 8.13581 34.7759C7.98647 34.9252 7.80914 34.9999 7.60381 34.9999H1.5558C1.35047 34.9999 1.17314 34.9252 1.0238 34.7759C0.874472 34.6266 0.799805 34.4492 0.799805 34.2439V16.1559C0.799805 15.9506 0.874472 15.7732 1.0238 15.6239C1.17314 15.4746 1.35047 15.3999 1.5558 15.3999H19.3638Z"
      fill="url(#paint0_linear_30_1508)"
    />
    <path
      d="M19.3638 15.3999C19.5691 15.3999 19.7465 15.4746 19.8958 15.6239C20.0451 15.7732 20.1198 15.9506 20.1198 16.1559V20.4119C20.1198 20.6172 20.0451 20.7946 19.8958 20.9439C19.7465 21.0932 19.5691 21.1679 19.3638 21.1679H8.35981V22.9599H17.5438C17.7491 22.9599 17.9265 23.0346 18.0758 23.1839C18.2251 23.3332 18.2998 23.5106 18.2998 23.7159V27.9439C18.2998 28.1492 18.2251 28.3266 18.0758 28.4759C17.9265 28.6252 17.7491 28.6999 17.5438 28.6999H8.35981V34.2439C8.35981 34.4492 8.28514 34.6266 8.13581 34.7759C7.98647 34.9252 7.80914 34.9999 7.60381 34.9999H1.5558C1.35047 34.9999 1.17314 34.9252 1.0238 34.7759C0.874472 34.6266 0.799805 34.4492 0.799805 34.2439V16.1559C0.799805 15.9506 0.874472 15.7732 1.0238 15.6239C1.17314 15.4746 1.35047 15.3999 1.5558 15.3999H19.3638Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M29.6569 34.0479C29.4142 34.6826 28.9942 34.9999 28.3969 34.9999H23.1049C22.9369 34.9999 22.7875 34.9439 22.6569 34.8319C22.5449 34.7012 22.4889 34.5519 22.4889 34.3839L22.5169 34.2159L28.6209 16.3239C28.6955 16.0812 28.8355 15.8666 29.0409 15.6799C29.2462 15.4932 29.5262 15.3999 29.8809 15.3999H37.6649C38.0195 15.3999 38.2995 15.4932 38.5049 15.6799C38.7102 15.8666 38.8502 16.0812 38.9249 16.3239L45.0289 34.2159L45.0569 34.3839C45.0569 34.5519 44.9915 34.7012 44.8609 34.8319C44.7489 34.9439 44.6089 34.9999 44.4409 34.9999H39.1489C38.5515 34.9999 38.1315 34.6826 37.8889 34.0479L37.1889 32.0879H30.3569L29.6569 34.0479ZM33.7729 20.8039L31.7849 26.6279H35.7609L33.7729 20.8039Z"
      fill="url(#paint1_linear_30_1508)"
    />
    <path
      d="M29.6569 34.0479C29.4142 34.6826 28.9942 34.9999 28.3969 34.9999H23.1049C22.9369 34.9999 22.7875 34.9439 22.6569 34.8319C22.5449 34.7012 22.4889 34.5519 22.4889 34.3839L22.5169 34.2159L28.6209 16.3239C28.6955 16.0812 28.8355 15.8666 29.0409 15.6799C29.2462 15.4932 29.5262 15.3999 29.8809 15.3999H37.6649C38.0195 15.3999 38.2995 15.4932 38.5049 15.6799C38.7102 15.8666 38.8502 16.0812 38.9249 16.3239L45.0289 34.2159L45.0569 34.3839C45.0569 34.5519 44.9915 34.7012 44.8609 34.8319C44.7489 34.9439 44.6089 34.9999 44.4409 34.9999H39.1489C38.5515 34.9999 38.1315 34.6826 37.8889 34.0479L37.1889 32.0879H30.3569L29.6569 34.0479ZM33.7729 20.8039L31.7849 26.6279H35.7609L33.7729 20.8039Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M67.1379 15.3999C67.3433 15.3999 67.5206 15.4746 67.6699 15.6239C67.8193 15.7732 67.8939 15.9506 67.8939 16.1559V20.6639C67.8939 20.8692 67.8193 21.0466 67.6699 21.1959C67.5206 21.3452 67.3433 21.4199 67.1379 21.4199H61.1179V34.2439C61.1179 34.4492 61.0433 34.6266 60.8939 34.7759C60.7446 34.9252 60.5673 34.9999 60.3619 34.9999H54.5939C54.3886 34.9999 54.2113 34.9252 54.0619 34.7759C53.9126 34.6266 53.8379 34.4492 53.8379 34.2439V21.4199H47.8179C47.6126 21.4199 47.4353 21.3452 47.2859 21.1959C47.1366 21.0466 47.0619 20.8692 47.0619 20.6639V16.1559C47.0619 15.9506 47.1366 15.7732 47.2859 15.6239C47.4353 15.4746 47.6126 15.3999 47.8179 15.3999H67.1379Z"
      fill="url(#paint2_linear_30_1508)"
    />
    <path
      d="M67.1379 15.3999C67.3433 15.3999 67.5206 15.4746 67.6699 15.6239C67.8193 15.7732 67.8939 15.9506 67.8939 16.1559V20.6639C67.8939 20.8692 67.8193 21.0466 67.6699 21.1959C67.5206 21.3452 67.3433 21.4199 67.1379 21.4199H61.1179V34.2439C61.1179 34.4492 61.0433 34.6266 60.8939 34.7759C60.7446 34.9252 60.5673 34.9999 60.3619 34.9999H54.5939C54.3886 34.9999 54.2113 34.9252 54.0619 34.7759C53.9126 34.6266 53.8379 34.4492 53.8379 34.2439V21.4199H47.8179C47.6126 21.4199 47.4353 21.3452 47.2859 21.1959C47.1366 21.0466 47.0619 20.8692 47.0619 20.6639V16.1559C47.0619 15.9506 47.1366 15.7732 47.2859 15.6239C47.4353 15.4746 47.6126 15.3999 47.8179 15.3999H67.1379Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M89.275 24.7799C90.003 25.0039 90.6283 25.4986 91.151 26.2639C91.6737 27.0106 91.935 27.8692 91.935 28.8399C91.935 30.9119 91.263 32.4612 89.919 33.4879C88.575 34.4959 86.615 34.9999 84.039 34.9999H72.503C72.2977 34.9999 72.1203 34.9252 71.971 34.7759C71.8217 34.6266 71.747 34.4492 71.747 34.2439V16.1559C71.747 15.9506 71.8217 15.7732 71.971 15.6239C72.1203 15.4746 72.2977 15.3999 72.503 15.3999H83.759C86.4097 15.3999 88.3603 15.8852 89.611 16.8559C90.8803 17.8079 91.515 19.2546 91.515 21.1959V21.2799C91.515 22.1759 91.2723 22.9412 90.787 23.5759C90.3017 24.2106 89.7977 24.6119 89.275 24.7799ZM83.927 21.4479C83.927 21.1119 83.8243 20.8226 83.619 20.5799C83.4323 20.3372 83.1523 20.2159 82.779 20.2159H79.027V22.7639H82.779C83.1523 22.7639 83.4323 22.6332 83.619 22.3719C83.8243 22.0919 83.927 21.7839 83.927 21.4479ZM83.087 30.1839C83.5163 30.1839 83.8337 30.0439 84.039 29.7639C84.263 29.4652 84.375 29.1386 84.375 28.7839V28.7559C84.375 28.4012 84.2537 28.0932 84.011 27.8319C83.787 27.5706 83.479 27.4399 83.087 27.4399H79.027V30.1839H83.087Z"
      fill="url(#paint3_linear_30_1508)"
    />
    <path
      d="M89.275 24.7799C90.003 25.0039 90.6283 25.4986 91.151 26.2639C91.6737 27.0106 91.935 27.8692 91.935 28.8399C91.935 30.9119 91.263 32.4612 89.919 33.4879C88.575 34.4959 86.615 34.9999 84.039 34.9999H72.503C72.2977 34.9999 72.1203 34.9252 71.971 34.7759C71.8217 34.6266 71.747 34.4492 71.747 34.2439V16.1559C71.747 15.9506 71.8217 15.7732 71.971 15.6239C72.1203 15.4746 72.2977 15.3999 72.503 15.3999H83.759C86.4097 15.3999 88.3603 15.8852 89.611 16.8559C90.8803 17.8079 91.515 19.2546 91.515 21.1959V21.2799C91.515 22.1759 91.2723 22.9412 90.787 23.5759C90.3017 24.2106 89.7977 24.6119 89.275 24.7799ZM83.927 21.4479C83.927 21.1119 83.8243 20.8226 83.619 20.5799C83.4323 20.3372 83.1523 20.2159 82.779 20.2159H79.027V22.7639H82.779C83.1523 22.7639 83.4323 22.6332 83.619 22.3719C83.8243 22.0919 83.927 21.7839 83.927 21.4479ZM83.087 30.1839C83.5163 30.1839 83.8337 30.0439 84.039 29.7639C84.263 29.4652 84.375 29.1386 84.375 28.7839V28.7559C84.375 28.4012 84.2537 28.0932 84.011 27.8319C83.787 27.5706 83.479 27.4399 83.087 27.4399H79.027V30.1839H83.087Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M114.128 29.5399C114.333 29.5399 114.511 29.6146 114.66 29.7639C114.809 29.9132 114.884 30.0906 114.884 30.2959V34.2439C114.884 34.4492 114.809 34.6266 114.66 34.7759C114.511 34.9252 114.333 34.9999 114.128 34.9999H96.4321C96.2267 34.9999 96.0494 34.9252 95.9001 34.7759C95.7507 34.6266 95.676 34.4492 95.676 34.2439V16.1559C95.676 15.9506 95.7507 15.7732 95.9001 15.6239C96.0494 15.4746 96.2267 15.3999 96.4321 15.3999H113.848C114.053 15.3999 114.231 15.4746 114.38 15.6239C114.529 15.7732 114.604 15.9506 114.604 16.1559V20.1039C114.604 20.3092 114.529 20.4866 114.38 20.6359C114.231 20.7852 114.053 20.8599 113.848 20.8599H102.956V22.6239H112.308C112.513 22.6239 112.691 22.6986 112.84 22.8479C112.989 22.9972 113.064 23.1746 113.064 23.3799V27.0199C113.064 27.2252 112.989 27.4026 112.84 27.5519C112.691 27.7012 112.513 27.7759 112.308 27.7759H102.956V29.5399H114.128Z"
      fill="url(#paint4_linear_30_1508)"
    />
    <path
      d="M114.128 29.5399C114.333 29.5399 114.511 29.6146 114.66 29.7639C114.809 29.9132 114.884 30.0906 114.884 30.2959V34.2439C114.884 34.4492 114.809 34.6266 114.66 34.7759C114.511 34.9252 114.333 34.9999 114.128 34.9999H96.4321C96.2267 34.9999 96.0494 34.9252 95.9001 34.7759C95.7507 34.6266 95.676 34.4492 95.676 34.2439V16.1559C95.676 15.9506 95.7507 15.7732 95.9001 15.6239C96.0494 15.4746 96.2267 15.3999 96.4321 15.3999H113.848C114.053 15.3999 114.231 15.4746 114.38 15.6239C114.529 15.7732 114.604 15.9506 114.604 16.1559V20.1039C114.604 20.3092 114.529 20.4866 114.38 20.6359C114.231 20.7852 114.053 20.8599 113.848 20.8599H102.956V22.6239H112.308C112.513 22.6239 112.691 22.6986 112.84 22.8479C112.989 22.9972 113.064 23.1746 113.064 23.3799V27.0199C113.064 27.2252 112.989 27.4026 112.84 27.5519C112.691 27.7012 112.513 27.7759 112.308 27.7759H102.956V29.5399H114.128Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M138.505 15.3999C138.71 15.3999 138.888 15.4746 139.037 15.6239C139.186 15.7732 139.261 15.9506 139.261 16.1559V20.6639C139.261 20.8692 139.186 21.0466 139.037 21.1959C138.888 21.3452 138.71 21.4199 138.505 21.4199H132.485V34.2439C132.485 34.4492 132.41 34.6266 132.261 34.7759C132.112 34.9252 131.934 34.9999 131.729 34.9999H125.961C125.756 34.9999 125.578 34.9252 125.429 34.7759C125.28 34.6266 125.205 34.4492 125.205 34.2439V21.4199H119.185C118.98 21.4199 118.802 21.3452 118.653 21.1959C118.504 21.0466 118.429 20.8692 118.429 20.6639V16.1559C118.429 15.9506 118.504 15.7732 118.653 15.6239C118.802 15.4746 118.98 15.3999 119.185 15.3999H138.505Z"
      fill="url(#paint5_linear_30_1508)"
    />
    <path
      d="M138.505 15.3999C138.71 15.3999 138.888 15.4746 139.037 15.6239C139.186 15.7732 139.261 15.9506 139.261 16.1559V20.6639C139.261 20.8692 139.186 21.0466 139.037 21.1959C138.888 21.3452 138.71 21.4199 138.505 21.4199H132.485V34.2439C132.485 34.4492 132.41 34.6266 132.261 34.7759C132.112 34.9252 131.934 34.9999 131.729 34.9999H125.961C125.756 34.9999 125.578 34.9252 125.429 34.7759C125.28 34.6266 125.205 34.4492 125.205 34.2439V21.4199H119.185C118.98 21.4199 118.802 21.3452 118.653 21.1959C118.504 21.0466 118.429 20.8692 118.429 20.6639V16.1559C118.429 15.9506 118.504 15.7732 118.653 15.6239C118.802 15.4746 118.98 15.3999 119.185 15.3999H138.505Z"
      fill="white"
      fillOpacity="0.95"
    />
    <defs>
      <filter
        id="filter0_d_30_1508"
        x="47.2246"
        y="0.052002"
        width="34.6523"
        height="39.5247"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30_1508"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30_1508"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_30_1508"
        x1="7.16667"
        y1="-8.96053"
        x2="116.8"
        y2="84.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCA1D" />
        <stop offset="1" stopColor="#A95B13" />
      </linearGradient>
    </defs>
  </svg>
  );
}
